export default {
  50230001: {
    cor: 'rgb(220, 252, 231)'
  },
  50230002: {
    cor: 'rgb(254, 249, 195)'
  },
  50230003: {
    cor: 'rgb(254, 202, 202)'
  },
  50230004: {
    cor: 'rgb(219, 234, 254)'
  },
  50230005: {
    cor: 'rgb(220, 252, 231)'
  }
}
